<div #tooltipContainer
  class="tooltip-container"
  [ngStyle]="{top: top,left:left}">
  <ng-content></ng-content>
  <ng-container #viewContainer></ng-container>
</div>
